
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexa076xfZ5599hM_45qEremYVZufAafrYYKt124SKUyIhfkMeta } from "/tmp/build_3ce305fc/pages/index.vue?macro=true";
import { default as confirmS_VLl3KPKmzeXV6p30wxXYH50KBzZuvsz2mrkdhpF9cMeta } from "/tmp/build_3ce305fc/pages/confirm.vue?macro=true";
import { default as supportBN7gKwsblVNTmUlckTRymi7_J1gdzQFv7FXNMFTF0psMeta } from "/tmp/build_3ce305fc/pages/support.vue?macro=true";
import { default as indexchUmD9dCQOznfcpn70ysjhJkvUhHhz07Y7ThJm6DlmkMeta } from "/tmp/build_3ce305fc/pages/map/index.vue?macro=true";
import { default as indexXzSnFm6_PXRTCc8UDMtHQEH8qt3X_45QDlgURk7_45w5htIMeta } from "/tmp/build_3ce305fc/pages/zemma/index.vue?macro=true";
import { default as teamDBNLVggC7HMRMeQcpH07PHWw01idFd7wGxyt2DHf_45zYMeta } from "/tmp/build_3ce305fc/pages/company/team.vue?macro=true";
import { default as imprintym4EPyVsB03az8_45ra1vrxgD0yfkh4kUgaLwHwLAS8CYMeta } from "/tmp/build_3ce305fc/pages/legal/imprint.vue?macro=true";
import { default as indexQ_45X0PReT81jgcHc_h8ed6Gnes7NrF_JDmfUn1hZYfuYMeta } from "/tmp/build_3ce305fc/pages/map/feed/index.vue?macro=true";
import { default as indexbsuC_RQdJD5OdwdqNtQ7mlPBYbl7V_Kia4tfQ7ZvzVUMeta } from "/tmp/build_3ce305fc/pages/dashboard/index.vue?macro=true";
import { default as indexDbmkgPR02OoAcCZjAiZuukrV_9_45xY8EpHmZbApzP_V8Meta } from "/tmp/build_3ce305fc/pages/auth/sign-in/index.vue?macro=true";
import { default as indexMr_45lFcErFtGrDZOy50ftLNN6YSIoR3r9urH_45yIPMmVkMeta } from "/tmp/build_3ce305fc/pages/auth/register/index.vue?macro=true";
import { default as error_45test_45page_45quoTa6IySRKTlBnuv7pXpKhYwUV_FCSeZLKpsyGjznDbXwMeta } from "/tmp/build_3ce305fc/pages/error-test-page-quo.vue?macro=true";
import { default as cancelZ7z_HHnpAbvgmj0bOc_45GZAWg57eg2k0_eqdJpfU7q6gMeta } from "/tmp/build_3ce305fc/pages/auth/checkout/cancel.vue?macro=true";
import { default as privacy_45policy_45wI9_7sYGGhi_BkD7811vGQbOCR0oaenAMkSsk3Ep0cMeta } from "/tmp/build_3ce305fc/pages/legal/privacy-policy.vue?macro=true";
import { default as successsp0GucCqvvAoE_45zPmqzP9qDU1djSlrF__45L18psA14acMeta } from "/tmp/build_3ce305fc/pages/auth/checkout/success.vue?macro=true";
import { default as share_45proZELC1fvcl_IV8Dk0v68oxnVMmp6VW61_yawhi3xtF5EMeta } from "/tmp/build_3ce305fc/pages/auth/invite/share-pro.vue?macro=true";
import { default as indexOC_3UUHS1GPdpYlumDZ1EKU0ry1H_459W94kfojVwnxugMeta } from "/tmp/build_3ce305fc/pages/dashboard/users/index.vue?macro=true";
import { default as _91_91id_93_93DeyoGS8VLRt28LaGNN0RXhOTXI5VuEnxhmNmr5H3NRcMeta } from "/tmp/build_3ce305fc/pages/dashboard/lists/[[id]].vue?macro=true";
import { default as _91_91id_93_93V0lhefGtnNViStsRJDWhpStjKnOI0qOZi9KDefRuAFwMeta } from "/tmp/build_3ce305fc/pages/dashboard/media/[[id]].vue?macro=true";
import { default as terms_45of_45servicewteFdS0ld9rqDJkWBY13jmO2dkQMJYXzbsSICgqVwV8Meta } from "/tmp/build_3ce305fc/pages/legal/terms-of-service.vue?macro=true";
import { default as _91_91id_93_93KDfsWXP1QtSrxrnqW10MjK8k_453qUr97gP_7rUaInB1MMeta } from "/tmp/build_3ce305fc/pages/dashboard/guides/[[id]].vue?macro=true";
import { default as _91_91id_93_93FRYGcVQ_uedZkGTkNXaCi35cK43HjpDTPEojQs1ehOkMeta } from "/tmp/build_3ce305fc/pages/dashboard/places/[[id]].vue?macro=true";
import { default as forward_45url2w2w03o_45BZbTcdCodgYhuaDrJzRKAgKsUuoCircidVAMeta } from "/tmp/build_3ce305fc/pages/auth/register/forward-url.vue?macro=true";
import { default as confirm_45emailn3uRabPW2OqAoTMBU7H9c5dJ67Y4DqxqcqFeP4TvQ70Meta } from "/tmp/build_3ce305fc/pages/auth/register/confirm-email.vue?macro=true";
import { default as reset_45passwordk6lGvGSM318EP6VAHQPFMOiCWfIimuHGZCRK2dlpdwsMeta } from "/tmp/build_3ce305fc/pages/auth/sign-in/reset-password.vue?macro=true";
import { default as _91_91slug_93_93FAPIAd88kBWoA0bCoOm3f9JsGNKcPmOIuhnb5X9TfZ8Meta } from "/tmp/build_3ce305fc/pages/map/place/[nanoId]/[[slug]].vue?macro=true";
import { default as choose_45productGmL0W_DQwolB7sxM893WhzViacJ_re5Zgbrw7BMmGcEMeta } from "/tmp/build_3ce305fc/pages/auth/checkout/choose-product.vue?macro=true";
import { default as create_45profilenzMEl2WioHgOQ7bQ54tnp9fJhuTkTKtU6jpLKZCmSzYMeta } from "/tmp/build_3ce305fc/pages/auth/register/create-profile.vue?macro=true";
import { default as _91_91id_93_93mWhbYnK6efzIgDJaSpXrt6m1_45R_enfCBKnWhgiD6k_45wMeta } from "/tmp/build_3ce305fc/pages/dashboard/helper/tags/[[id]].vue?macro=true";
import { default as _91_91slug_93_93okUQHx1BMcSgitddj1ZlmO4_hXpKjP0hnWDfVMTG5k0Meta } from "/tmp/build_3ce305fc/pages/map/list/[[nanoId]]/[[slug]].vue?macro=true";
import { default as success_45quo_45proBBYQBNd05GRoFu3_45UiaZ022r_bAQ9UpsBRRF0WWfT0cMeta } from "/tmp/build_3ce305fc/pages/auth/checkout/success-quo-pro.vue?macro=true";
import { default as share_45pro_45successcfhH41ekEa1ckXApEb0DFlugNWAuvwi8XR_YPxeA_7kMeta } from "/tmp/build_3ce305fc/pages/auth/invite/share-pro-success.vue?macro=true";
import { default as send_45password_45linkhGQKEeb_45MAPPMBG2E0381W9ZbAWVyLJLlRNGrMGA18sMeta } from "/tmp/build_3ce305fc/pages/auth/sign-in/send-password-link.vue?macro=true";
import { default as indexzAg8ClzyLSuQ_b6wCtd5PDNQcnRs5A3QCAaUcPHkTn4Meta } from "/tmp/build_3ce305fc/pages/dashboard/helper/countries/index.vue?macro=true";
import { default as _91highlightUrlName_93rrSRKxDgdt_45Wwdd7xEvJ2fxZKBwlKQsaAtN37Jw6Y0AMeta } from "/tmp/build_3ce305fc/pages/map/highlight/[highlightUrlName].vue?macro=true";
import { default as indexcckrjiMf75qFMkCq1O9CFcdP347bGEZ36V3bWMBOFbYMeta } from "/tmp/build_3ce305fc/pages/map/guide/[nanoId]/[title]/[[key]]/index.vue?macro=true";
export default [
  {
    name: "index___en",
    path: "/",
    meta: indexa076xfZ5599hM_45qEremYVZufAafrYYKt124SKUyIhfkMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/index.vue")
  },
  {
    name: "confirm___en",
    path: "/confirm",
    component: () => import("/tmp/build_3ce305fc/pages/confirm.vue")
  },
  {
    name: "support___en",
    path: "/support",
    component: () => import("/tmp/build_3ce305fc/pages/support.vue")
  },
  {
    name: "map___en",
    path: "/map",
    meta: indexchUmD9dCQOznfcpn70ysjhJkvUhHhz07Y7ThJm6DlmkMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/map/index.vue")
  },
  {
    name: "zemma___en",
    path: "/zemma",
    component: () => import("/tmp/build_3ce305fc/pages/zemma/index.vue")
  },
  {
    name: "company-team___en",
    path: "/company/team",
    component: () => import("/tmp/build_3ce305fc/pages/company/team.vue")
  },
  {
    name: "legal-imprint___en",
    path: "/legal/imprint",
    component: () => import("/tmp/build_3ce305fc/pages/legal/imprint.vue")
  },
  {
    name: "map-feed___en",
    path: "/map/feed",
    meta: indexQ_45X0PReT81jgcHc_h8ed6Gnes7NrF_JDmfUn1hZYfuYMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/map/feed/index.vue")
  },
  {
    name: "dashboard___en",
    path: "/dashboard",
    meta: indexbsuC_RQdJD5OdwdqNtQ7mlPBYbl7V_Kia4tfQ7ZvzVUMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/dashboard/index.vue")
  },
  {
    name: "auth-sign-in___en",
    path: "/auth/sign-in",
    meta: indexDbmkgPR02OoAcCZjAiZuukrV_9_45xY8EpHmZbApzP_V8Meta || {},
    component: () => import("/tmp/build_3ce305fc/pages/auth/sign-in/index.vue")
  },
  {
    name: "auth-register___en",
    path: "/auth/register",
    meta: indexMr_45lFcErFtGrDZOy50ftLNN6YSIoR3r9urH_45yIPMmVkMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/auth/register/index.vue")
  },
  {
    name: "error-test-page-quo___en",
    path: "/error-test-page-quo",
    component: () => import("/tmp/build_3ce305fc/pages/error-test-page-quo.vue")
  },
  {
    name: "auth-checkout-cancel___en",
    path: "/auth/checkout/cancel",
    meta: cancelZ7z_HHnpAbvgmj0bOc_45GZAWg57eg2k0_eqdJpfU7q6gMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/auth/checkout/cancel.vue")
  },
  {
    name: "legal-privacy-policy___en",
    path: "/legal/privacy-policy",
    component: () => import("/tmp/build_3ce305fc/pages/legal/privacy-policy.vue")
  },
  {
    name: "auth-checkout-success___en",
    path: "/auth/checkout/success",
    meta: successsp0GucCqvvAoE_45zPmqzP9qDU1djSlrF__45L18psA14acMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/auth/checkout/success.vue")
  },
  {
    name: "auth-invite-share-pro___en",
    path: "/auth/invite/share-pro",
    meta: share_45proZELC1fvcl_IV8Dk0v68oxnVMmp6VW61_yawhi3xtF5EMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/auth/invite/share-pro.vue")
  },
  {
    name: "dashboard-users___en",
    path: "/dashboard/users",
    meta: indexOC_3UUHS1GPdpYlumDZ1EKU0ry1H_459W94kfojVwnxugMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/dashboard/users/index.vue")
  },
  {
    name: "dashboard-lists-id___en",
    path: "/dashboard/lists/:id?",
    meta: _91_91id_93_93DeyoGS8VLRt28LaGNN0RXhOTXI5VuEnxhmNmr5H3NRcMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/dashboard/lists/[[id]].vue")
  },
  {
    name: "dashboard-media-id___en",
    path: "/dashboard/media/:id?",
    meta: _91_91id_93_93V0lhefGtnNViStsRJDWhpStjKnOI0qOZi9KDefRuAFwMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/dashboard/media/[[id]].vue")
  },
  {
    name: "legal-terms-of-service___en",
    path: "/legal/terms-of-service",
    component: () => import("/tmp/build_3ce305fc/pages/legal/terms-of-service.vue")
  },
  {
    name: "dashboard-guides-id___en",
    path: "/dashboard/guides/:id?",
    meta: _91_91id_93_93KDfsWXP1QtSrxrnqW10MjK8k_453qUr97gP_7rUaInB1MMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/dashboard/guides/[[id]].vue")
  },
  {
    name: "dashboard-places-id___en",
    path: "/dashboard/places/:id?",
    meta: _91_91id_93_93FRYGcVQ_uedZkGTkNXaCi35cK43HjpDTPEojQs1ehOkMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/dashboard/places/[[id]].vue")
  },
  {
    name: "auth-register-forward-url___en",
    path: "/auth/register/forward-url",
    meta: forward_45url2w2w03o_45BZbTcdCodgYhuaDrJzRKAgKsUuoCircidVAMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/auth/register/forward-url.vue")
  },
  {
    name: "auth-register-confirm-email___en",
    path: "/auth/register/confirm-email",
    meta: confirm_45emailn3uRabPW2OqAoTMBU7H9c5dJ67Y4DqxqcqFeP4TvQ70Meta || {},
    component: () => import("/tmp/build_3ce305fc/pages/auth/register/confirm-email.vue")
  },
  {
    name: "auth-sign-in-reset-password___en",
    path: "/auth/sign-in/reset-password",
    meta: reset_45passwordk6lGvGSM318EP6VAHQPFMOiCWfIimuHGZCRK2dlpdwsMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/auth/sign-in/reset-password.vue")
  },
  {
    name: "map-place-nanoId-slug___en",
    path: "/map/place/:nanoId()/:slug?",
    meta: _91_91slug_93_93FAPIAd88kBWoA0bCoOm3f9JsGNKcPmOIuhnb5X9TfZ8Meta || {},
    component: () => import("/tmp/build_3ce305fc/pages/map/place/[nanoId]/[[slug]].vue")
  },
  {
    name: "auth-checkout-choose-product___en",
    path: "/auth/checkout/choose-product",
    meta: choose_45productGmL0W_DQwolB7sxM893WhzViacJ_re5Zgbrw7BMmGcEMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/auth/checkout/choose-product.vue")
  },
  {
    name: "auth-register-create-profile___en",
    path: "/auth/register/create-profile",
    meta: create_45profilenzMEl2WioHgOQ7bQ54tnp9fJhuTkTKtU6jpLKZCmSzYMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/auth/register/create-profile.vue")
  },
  {
    name: "dashboard-helper-tags-id___en",
    path: "/dashboard/helper/tags/:id?",
    meta: _91_91id_93_93mWhbYnK6efzIgDJaSpXrt6m1_45R_enfCBKnWhgiD6k_45wMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/dashboard/helper/tags/[[id]].vue")
  },
  {
    name: "map-list-nanoId-slug___en",
    path: "/map/list/:nanoId?/:slug?",
    meta: _91_91slug_93_93okUQHx1BMcSgitddj1ZlmO4_hXpKjP0hnWDfVMTG5k0Meta || {},
    component: () => import("/tmp/build_3ce305fc/pages/map/list/[[nanoId]]/[[slug]].vue")
  },
  {
    name: "auth-checkout-success-quo-pro___en",
    path: "/auth/checkout/success-quo-pro",
    meta: success_45quo_45proBBYQBNd05GRoFu3_45UiaZ022r_bAQ9UpsBRRF0WWfT0cMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/auth/checkout/success-quo-pro.vue")
  },
  {
    name: "auth-invite-share-pro-success___en",
    path: "/auth/invite/share-pro-success",
    meta: share_45pro_45successcfhH41ekEa1ckXApEb0DFlugNWAuvwi8XR_YPxeA_7kMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/auth/invite/share-pro-success.vue")
  },
  {
    name: "auth-sign-in-send-password-link___en",
    path: "/auth/sign-in/send-password-link",
    meta: send_45password_45linkhGQKEeb_45MAPPMBG2E0381W9ZbAWVyLJLlRNGrMGA18sMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/auth/sign-in/send-password-link.vue")
  },
  {
    name: "dashboard-helper-countries___en",
    path: "/dashboard/helper/countries",
    meta: indexzAg8ClzyLSuQ_b6wCtd5PDNQcnRs5A3QCAaUcPHkTn4Meta || {},
    component: () => import("/tmp/build_3ce305fc/pages/dashboard/helper/countries/index.vue")
  },
  {
    name: "map-highlight-highlightUrlName___en",
    path: "/map/highlight/:highlightUrlName()",
    meta: _91highlightUrlName_93rrSRKxDgdt_45Wwdd7xEvJ2fxZKBwlKQsaAtN37Jw6Y0AMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/map/highlight/[highlightUrlName].vue")
  },
  {
    name: "map-guide-nanoId-title-key___en",
    path: "/map/guide/:nanoId()/:title()/:key?",
    meta: indexcckrjiMf75qFMkCq1O9CFcdP347bGEZ36V3bWMBOFbYMeta || {},
    component: () => import("/tmp/build_3ce305fc/pages/map/guide/[nanoId]/[title]/[[key]]/index.vue")
  }
]